import { PolygonLabelInput } from 'features/kestrelViewer/ui/popupMenu/polygonMenu/PolygonLabelInput'
import { PolygonNotesInput } from 'features/kestrelViewer/ui/popupMenu/polygonMenu/PolygonNotesInput'
import { StatusDropdown } from 'features/kestrelViewer/ui/popupMenu/polygonMenu/StatusDropdown'
import React, { FC } from 'react'
import styled from 'styled-components'
import { KVPolygon } from 'types'

const PolygonSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
  width: 100%;
`

export const PolygonMenu: FC<{
  selectedPolygon: KVPolygon
}> = ({ selectedPolygon }) => {
  return (
    <>
      <PolygonLabelInput selectedPolygon={selectedPolygon} />
      <PolygonSection>
        <StatusDropdown selectedPolygon={selectedPolygon} />
      </PolygonSection>
      <PolygonSection>
        <div>Notes</div>
        <PolygonNotesInput selectedPolygon={selectedPolygon} />
      </PolygonSection>
    </>
  )
}
